
define('text!modules/audiences/segments/templates/addSegmentButton.html',[],function () { return '<strand-button type="primary" class="column add-segment">\n  <strand-icon type="plus" width="14" height="14"></strand-icon>\n  <label id="label"></label>\n</strand-button>\n';});

